/** Flat bonus when Hourglass (`h`) pays out (correct 1×2 at FT). */
const HOURGLASS_POINTS = 8;
const HOURGLASS_MOVE_COST = 2;
const HOURGLASS_MIN_POINTS = 2;

const HOURGLASS_AUGMENT_CODE = 'h';

const HOURGLASS_POINT_STEPS = new Set([8, 6, 4, 2]);

/** Live phases where the second half has started (Hourglass placement closed). */
const SECOND_HALF_STARTED_PHASES = new Set(['2H', 'ET', 'BT', 'P', 'AET', 'PEN', 'FT']);

function livePhaseOf(game) {
  return String(game?.livePhase ?? game?.lph ?? '').toUpperCase();
}

/**
 * True while Hourglass may be placed on this fixture (scheduled, 1H, or HT — before 2H).
 * @param {Record<string, unknown> | null | undefined} game
 */
function isHourglassPlacementOpenForGame(game) {
  if (!game) return false;
  const status = String(game.status || '').toLowerCase();
  if (status === 'finished' || status === 'postponed' || status === 'canceled' || status === 'cancelled') {
    return false;
  }
  if (game.secondHalfStartedAt != null || game.shsa != null) return false;
  const phase = livePhaseOf(game);
  if (SECOND_HALF_STARTED_PHASES.has(phase)) return false;
  return true;
}

/**
 * Remaining Hourglass bonus (8/6/4/2). Missing or invalid values score as 8.
 * @param {unknown} raw
 */
function resolveHourglassPoints(raw) {
  const n = Number(raw);
  if (HOURGLASS_POINT_STEPS.has(n)) return n;
  return HOURGLASS_POINTS;
}

/**
 * True while a post-lock hop is still allowed (remaining > 2).
 * @param {unknown} raw
 */
function canMoveHourglass(raw) {
  return resolveHourglassPoints(raw) > HOURGLASS_MIN_POINTS;
}

/**
 * Bonus after one post-lock hop. Unchanged when already at the floor.
 * @param {unknown} raw
 */
function nextHourglassPoints(raw) {
  const current = resolveHourglassPoints(raw);
  if (!canMoveHourglass(current)) return current;
  return current - HOURGLASS_MOVE_COST;
}

module.exports = {
  HOURGLASS_POINTS,
  HOURGLASS_MOVE_COST,
  HOURGLASS_MIN_POINTS,
  HOURGLASS_AUGMENT_CODE,
  isHourglassPlacementOpenForGame,
  livePhaseOf,
  resolveHourglassPoints,
  canMoveHourglass,
  nextHourglassPoints
};
